import { ArrowUpRight, Footprints, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { pacerClub, whatsappChannel } from "../content/site";

const icons = { pacer: Footprints, whatsapp: MessageCircle };

export default function CommunityTiles({ tiles, testIdPrefix = "community-tile" }) {
  return (
    <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
      {tiles.map((tile, i) => {
        const Icon = icons[tile.key];
        const url = tile.key === "pacer" ? pacerClub.url : whatsappChannel.url;
        const accent = tile.key === "pacer" ? "#43D2FF" : "#FF2F89";
        const accentText = tile.key === "pacer" ? "#0B7A8C" : "#D6106A";
        const onAccent = tile.key === "pacer" ? "#1C1917" : "#F7F5F0";
        return (
          <Reveal key={tile.key} delay={i * 0.1}>
            <div
              data-testid={`${testIdPrefix}-${tile.key}`}
              className="group flex flex-col h-full border rounded-xl p-8 md:p-12 transition-transform duration-500 hover:-translate-y-1"
              style={{ borderColor: `${accent}73`, backgroundColor: `${accent}0D` }}
            >
              <div className="flex items-center justify-between gap-4">
                <span
                  className="h-14 w-14 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: `${accent}33`, color: accentText }}
                >
                  <Icon className="h-6 w-6" />
                </span>
                <span
                  className="text-[0.65rem] font-semibold uppercase tracking-[0.22em]"
                  style={{ color: accentText }}
                >
                  {tile.eyebrow}
                </span>
              </div>
              <h3 className="mt-8 font-serif text-3xl md:text-4xl tracking-tight text-ink">{tile.title}</h3>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-ink-2 grow">{tile.text}</p>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${tile.cta} (opens in new tab)`}
                data-testid={`${testIdPrefix}-${tile.key}-cta`}
                className="mt-8 inline-flex items-center gap-2 self-start rounded-full px-6 py-3 text-sm font-semibold whitespace-nowrap transition-all duration-300 hover:scale-[1.04] active:scale-95"
                style={{ backgroundColor: accent, color: onAccent }}
              >
                {tile.cta}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}
